// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background[data-v-68c97b67]{background-color:#fff;padding-top:4%;padding-left:4%;padding-right:4%;padding-bottom:4%;border-radius:7px}.loading[data-v-68c97b67]{min-height:425px!important;min-width:638px!important}", ""]);
// Exports
module.exports = exports;
